import { render } from "./ViewTab.vue?vue&type=template&id=b95e7c00&scoped=true"
import script from "./ViewTab.vue?vue&type=script&lang=js"
export * from "./ViewTab.vue?vue&type=script&lang=js"

import "./ViewTab.vue?vue&type=style&index=0&id=b95e7c00&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b95e7c00"]])

export default __exports__